<template>
  <el-row
    style="
      height: 80px;
      font-size: 40px;
      font-weight: 600;
      color: rgb(50, 90, 170);
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 840px;
    "
  >
    原创技术文档
  </el-row>
  <el-divider></el-divider>
  <section style="max-width: 960px; min-width: 840px; margin: auto">
    <el-row :gutter="40">
      <el-col :span="11">
        <a :href="url1" target="_blank" class="no-underline title-resource"
          >规范规定与实际工况，你选谁？</a
        >
        <div class="text-resource">
          规范规定存在传承，规范的变更都符合时代的进步。
          预应力结构正截面应力验算的不正常现象，需要你进行判断。
        </div>
        <el-divider></el-divider>
        <a :href="url3" target="_blank" class="no-underline title-resource"
          >桩基有限元模拟（单桩篇）</a
        >
        <div class="text-resource">
          复杂地质条件下桩基受力、变形计算已经无法使用规范公式，
          如何充分利用Midas Civil进行桩基有限元模拟，你需要思考。
        </div>
        <el-divider></el-divider>
        <a :href="url5" target="_blank" class="no-underline title-resource"
          >装配式结构整体模型计算精度对比</a
        >
        <div class="text-resource">
          有限元方式建立全桥整体模型进行计算， 让桥墩墩身计算更加高效。
        </div>
        <el-divider></el-divider>
        <a :href="url7" target="_blank" class="no-underline title-resource"
          >箱梁精细化模型实际应用（一）</a
        >
        <div class="text-resource">
          箱梁结构的横向应力存在不均匀现象， 影响因素有哪些？让我们对比一下。
        </div>
        <el-divider></el-divider>
        <a :href="url9" target="_blank" class="no-underline title-resource"
          >抗剪截面尺寸要求，你真的搞懂了吗？</a
        >
        <div class="text-resource">
          抗剪验算总是不过，是截面尺寸之过吗？
          结构中哪些地方需要进行抗剪验算中的截面尺寸验算？
        </div>
      </el-col>
      <el-col :span="2">
        <el-divider direction="vertical" style="height: 800px"></el-divider>
      </el-col>
      <el-col :span="11">
        <a :href="url2" target="_blank" class="no-underline title-resource"
          >程序与规范，你如何理解？</a
        >
        <div class="text-resource">
          规范的规定是基于不利状态的，是有使用范围的，
          程序如何使用还是需要基于对规范的理解。
        </div>
        <el-divider></el-divider>
        <a :href="url4" target="_blank" class="no-underline title-resource"
          >桩基有限元模拟（群桩篇）</a
        >
        <div class="text-resource">
          复杂的群桩结构，规范公式难以适应实际情况。
          有限元建模方式，能够达到你想要的精度。
        </div>
        <el-divider></el-divider>
        <a :href="url6" target="_blank" class="no-underline title-resource"
          >桥墩计算长度如何计算？</a
        >
        <div class="text-resource">
          常规结构的桥墩长度通常采用经验系数的方式，
          让我们用有限元建模的方式得到足够精度的桥墩计算长度。
        </div>
        <el-divider></el-divider>
        <a :href="url8" target="_blank" class="no-underline title-resource"
          >箱梁精细化模型实际应用（二）</a
        >
        <div class="text-resource">
          箱梁结构的横向应力存在不均匀现象， 影响因素有哪些？让我们对比一下。
        </div>
        <el-divider></el-divider>
      </el-col>
    </el-row>
  </section>
</template>
<script>
export default {
  data() {
    return {
      url1: "https://mp.weixin.qq.com/s/yDI-rkrOTlEcgy5m7AqInw",
      url2: "https://mp.weixin.qq.com/s/qY6uAiPQs06fnRxl894t5A",
      url3: "https://mp.weixin.qq.com/s/x61IvqjFrXYZaZkarGknTg",
      url4: "https://mp.weixin.qq.com/s/N6S4EUtWoW73qF9DwbR3Kg",
      url5: "https://mp.weixin.qq.com/s/L7b_szPj7D2bSyzsxmaoNA",
      url6: "https://mp.weixin.qq.com/s/eSxfG5xlRXIIIvDr5A7KUA",
      url7: "https://mp.weixin.qq.com/s/qNwNcJKNSo1-NNvRsEgMGw",
      url8: "https://mp.weixin.qq.com/s/0kJEhlpLXCz84jR46xItKQ",
      url9: "https://mp.weixin.qq.com/s/qQrUF56gn0dC_Tz6qOZpsQ",
    };
  },
};
</script>
<style>
.title-resource {
  max-width: 320px;
  padding: 10px;
  margin: auto;
  height: 40px;
  font-size: 20px;
  font-weight: 800;
  color: rgb(50, 90, 170);
}
.text-resource {
  max-width: 320px;
  padding: 10px;
  margin: auto;
  height: 60px;
  font-size: 15px;
  font-weight: 400;
  line-height: 2;
  text-align: left;
}
</style>
